import React from 'react';
import styles from './pane.module.scss';
import classNames from 'classnames';
import { H4 } from '../../../text';

type PaneProps = {
  title?: string | null | undefined;
  limitWidth?: boolean;
  noTopMargin?: boolean;
  children: React.ReactNode;
}

/**
 * A pane that sits within the main width and contains logically grouped items
 * @param {string} [props.title]
 * @param {boolean} [props.noTopMargin]
 * @param {boolean} [props.limitWidth]
 * @param {React.ReactNode} props.children
 * @returns {JSX.Element}
 */
export const Pane: React.FC<PaneProps> = ({ title, children, noTopMargin = false, limitWidth = false, fullHeight = false }) => (
  <div className={classNames(
    styles.pane,
    noTopMargin ? styles.paneNoTopMargin : '',
    limitWidth ? styles.limitWidth : '',
    fullHeight ? styles.paneFullHeight : ''
  )}>
    {
      title && <div className={styles.title}>
        <H4>{title}</H4>
      </div>
    }
    {children}
  </div>
);
